import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AssetCategoriesService, AssetCategory } from '../../services/asset-categories.service';
import { AssetCategoryDialogComponent, AssetCategoryDialogData } from './asset-category-dialog.component';

@Component({
  selector: 'app-asset-categories',
  templateUrl: './asset-categories.component.html',
  styleUrls: ['./asset-categories.component.css']
})
export class AssetCategoriesComponent implements OnInit {
  displayedColumns: string[] = ['id', 'name', 'description', 'depreciationRate', 'usefulLife', 'actions'];
  dataSource = new MatTableDataSource<AssetCategory>();
  isLoading = false;

  constructor(
    private assetCategoriesService: AssetCategoriesService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.loadAssetCategories();
  }

  loadAssetCategories(): void {
    this.isLoading = true;
    this.assetCategoriesService.getAssetCategories().subscribe({
      next: (response) => {
        if (response.success) {
          this.dataSource.data = response.data;
        } else {
          this.snackBar.open(response.message || 'Failed to load asset categories', 'Close', { duration: 3000 });
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading asset categories:', error);
        this.snackBar.open('Error loading asset categories', 'Close', { duration: 3000 });
        this.isLoading = false;
      }
    });
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  addCategory(): void {
    const dialogData: AssetCategoryDialogData = {
      title: 'Add New Asset Category'
    };

    const dialogRef = this.dialog.open(AssetCategoryDialogComponent, {
      width: '600px',
      data: dialogData,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadAssetCategories(); // Refresh the list
      }
    });
  }

  editCategory(category: AssetCategory): void {
    const dialogData: AssetCategoryDialogData = {
      title: 'Edit Asset Category',
      assetCategory: category
    };

    const dialogRef = this.dialog.open(AssetCategoryDialogComponent, {
      width: '600px',
      data: dialogData,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadAssetCategories(); // Refresh the list
      }
    });
  }

  deleteCategory(category: AssetCategory): void {
    if (confirm(`Are you sure you want to delete ${category.name}? This action cannot be undone.`)) {
      if (category.id) {
        this.assetCategoriesService.deleteAssetCategory(category.id).subscribe({
          next: (response) => {
            if (response.success) {
              this.snackBar.open('Asset category deleted successfully', 'Close', { duration: 3000 });
              this.loadAssetCategories(); // Refresh the list
            } else {
              this.snackBar.open(response.message || 'Failed to delete asset category', 'Close', { duration: 3000 });
            }
          },
          error: (error) => {
            console.error('Error deleting asset category:', error);
            this.snackBar.open('Error deleting asset category', 'Close', { duration: 3000 });
          }
        });
      }
    }
  }
}
